import { useState, useEffect } from "react";
import { getAllApplications } from "../../services/api";
const BASE = "https://imalishawelfare.com/api";

export default function Loans() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("ALL");

  useEffect(()=>{ load(); }, []);

  const load = async () => {
    try {
      const data = await getAllApplications();
      setLoans(data.filter(a => a.selectedLoanAmount || a.loanStatus));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const statuses = ["ALL","PENDING_FEE","FEE_PAID","DISBURSED","FAILED"];
  const filtered = filter==="ALL" ? loans : loans.filter(l=>l.loanStatus===filter);
  const total = loans.reduce((s,l)=>s+(l.selectedLoanAmount||0),0);
  const fees = loans.reduce((s,l)=>s+(l.loanFeeAmount||0),0);
  const disbursed = loans.filter(l=>l.loanStatus==="DISBURSED").reduce((s,l)=>s+(l.selectedLoanAmount||0),0);

  const statusColor = s => ({ PENDING_FEE:"#f59e0b", FEE_PAID:"#0066cc", DISBURSED:"#10b981", FAILED:"#ef4444" }[s]||"#94a3b8");

  const manualDisburse = async (appId) => {
    if (!window.confirm("Mark this loan as disbursed?")) return;
    try {
      const token = sessionStorage.getItem("token");
      await fetch(`${BASE}/applications/${appId}/disburse`, { method:"PUT", headers:{ "Authorization":"Bearer "+token, "Content-Type":"application/json" } });
      load();
    } catch(e) { alert("Failed: "+e.message); }
  };

  return (
    <div>
      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:16, marginBottom:24 }}>
        {[["Total Loans",loans.length,"#0066cc"],["Total Amount","KSh "+total.toLocaleString(),"#7c3aed"],["Fees Collected","KSh "+fees.toLocaleString(),"#f59e0b"],["Disbursed","KSh "+disbursed.toLocaleString(),"#10b981"]].map(([l,v,c])=>(
          <div key={l} style={{ background:"white", borderRadius:12, padding:"18px 20px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)", borderLeft:"4px solid "+c }}>
            <p style={{ fontSize:12, color:"#64748b", margin:"0 0 6px", fontWeight:600, textTransform:"uppercase", letterSpacing:.5 }}>{l}</p>
            <p style={{ fontSize:22, fontWeight:800, color:c, margin:0 }}>{v}</p>
          </div>
        ))}
      </div>

      {/* Filter */}
      <div style={{ background:"white", borderRadius:12, padding:"16px 20px", marginBottom:16, display:"flex", gap:8, flexWrap:"wrap", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
        {statuses.map(s=>(
          <button key={s} onClick={()=>setFilter(s)} style={{ padding:"6px 14px", borderRadius:20, border:"none", cursor:"pointer", fontSize:12, fontWeight:600, background:filter===s?"#0066cc":"#f1f5f9", color:filter===s?"white":"#64748b" }}>{s}</button>
        ))}
        <button onClick={load} style={{ marginLeft:"auto", padding:"6px 14px", borderRadius:20, border:"none", cursor:"pointer", fontSize:12, fontWeight:600, background:"#f1f5f9", color:"#64748b" }}>Refresh</button>
      </div>

      {/* Table */}
      <div style={{ background:"white", borderRadius:12, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
          <thead>
            <tr style={{ background:"#f8fafc" }}>
              {["ID","Applicant","Phone","County","Loan Amount","Fee","Status","Action"].map(h=>(
                <th key={h} style={{ padding:"12px 16px", textAlign:"left", fontWeight:700, color:"#64748b", fontSize:11, textTransform:"uppercase", letterSpacing:.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={8} style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>Loading...</td></tr>
            : filtered.length===0 ? <tr><td colSpan={8} style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>No loans found</td></tr>
            : filtered.map(l=>(
              <tr key={l.id} style={{ borderTop:"1px solid #f1f5f9" }}>
                <td style={{ padding:"12px 16px", color:"#0066cc", fontWeight:700 }}>APP-{l.id}</td>
                <td style={{ padding:"12px 16px" }}>
                  <div style={{ fontWeight:600 }}>{l.fullName}</div>
                  <div style={{ fontSize:11, color:"#94a3b8" }}>{l.email}</div>
                </td>
                <td style={{ padding:"12px 16px", color:"#64748b" }}>{l.phone||"�"}</td>
                <td style={{ padding:"12px 16px", color:"#64748b" }}>{l.county||"�"}</td>
                <td style={{ padding:"12px 16px", fontWeight:700 }}>KSh {(l.selectedLoanAmount||0).toLocaleString()}</td>
                <td style={{ padding:"12px 16px", color:"#10b981", fontWeight:600 }}>KSh {(l.loanFeeAmount||0).toLocaleString()}</td>
                <td style={{ padding:"12px 16px" }}>
                  <span style={{ background:statusColor(l.loanStatus)+"20", color:statusColor(l.loanStatus), borderRadius:20, padding:"3px 10px", fontSize:11, fontWeight:700 }}>{l.loanStatus||"NO LOAN"}</span>
                </td>
                <td style={{ padding:"12px 16px" }}>
                  {l.loanStatus==="FEE_PAID" && <button onClick={()=>manualDisburse(l.id)} style={{ padding:"5px 12px", background:"#10b981", color:"white", border:"none", borderRadius:6, fontSize:12, fontWeight:600, cursor:"pointer" }}>Mark Disbursed</button>}
                  {l.loanStatus==="DISBURSED" && <span style={{ fontSize:12, color:"#10b981", fontWeight:600 }}>? Done</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}



